import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "./components/theme-provider"
import { Layout } from "./components/layout"
import { 
  HomePage, 
  NestJSOverviewPage, 
  NestMySQLPage,
  MongoDBOverviewPage,
  MongoDBQuickStartPage,
  MongoDBFeaturesPage,
  MongoDBStructurePage,
  MongoDBConfigurationPage,
  MongoDBAuthenticationPage,
  MongoDBScriptsPage,
  MySQLOverviewPage,
  MySQLQuickStartPage,
  MySQLFeaturesPage,
  MySQLStructurePage,
  MySQLMigrationsPage,
  MySQLEntitiesPage,
  MySQLConfigurationPage,
  MySQLScriptsPage,
  // React + Shadcn
  ReactShadcnOverviewPage,
  ReactShadcnQuickStartPage,
  ReactShadcnFeaturesPage,
  ReactShadcnArchitecturePage,
  ReactShadcnComponentsPage,
  ReactShadcnServicesPage,
  ReactShadcnStatePage,
  ReactShadcnThemingPage,
  // React + Tailwind
  ReactTailwindOverviewPage,
  ReactTailwindQuickStartPage,
  ReactTailwindFeaturesPage,
  ReactTailwindArchitecturePage,
  ReactTailwindComponentsPage,
  ReactTailwindServicesPage,
  ReactTailwindStatePage,
  // Next.js + Shadcn
  NextShadcnOverviewPage,
  NextShadcnQuickStartPage,
  NextShadcnFeaturesPage,
  NextShadcnArchitecturePage,
  NextShadcnComponentsPage,
  NextShadcnServerClientPage,
  NextShadcnStatePage,
  // Next.js + Tailwind
  NextTailwindOverviewPage,
  NextTailwindQuickStartPage,
  NextTailwindFeaturesPage,
  NextTailwindArchitecturePage,
  NextTailwindComponentsPage,
  NextTailwindServerClientPage,
  NextTailwindStatePage
} from "./pages"

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="nest-templates-theme">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="nestjs" element={<NestJSOverviewPage />} />
            
            {/* MongoDB Routes */}
            <Route path="nestjs/mongodb" element={<MongoDBOverviewPage />} />
            <Route path="nestjs/mongodb/quick-start" element={<MongoDBQuickStartPage />} />
            <Route path="nestjs/mongodb/features" element={<MongoDBFeaturesPage />} />
            <Route path="nestjs/mongodb/structure" element={<MongoDBStructurePage />} />
            <Route path="nestjs/mongodb/configuration" element={<MongoDBConfigurationPage />} />
            <Route path="nestjs/mongodb/authentication" element={<MongoDBAuthenticationPage />} />
            <Route path="nestjs/mongodb/scripts" element={<MongoDBScriptsPage />} />
            
            {/* MySQL Routes */}
            <Route path="nestjs/mysql" element={<MySQLOverviewPage />} />
            <Route path="nestjs/mysql/quick-start" element={<MySQLQuickStartPage />} />
            <Route path="nestjs/mysql/features" element={<MySQLFeaturesPage />} />
            <Route path="nestjs/mysql/structure" element={<MySQLStructurePage />} />
            <Route path="nestjs/mysql/migrations" element={<MySQLMigrationsPage />} />
            <Route path="nestjs/mysql/entities" element={<MySQLEntitiesPage />} />
            <Route path="nestjs/mysql/configuration" element={<MySQLConfigurationPage />} />
            <Route path="nestjs/mysql/scripts" element={<MySQLScriptsPage />} />
            
            {/* React + Shadcn Routes */}
            <Route path="react/shadcn" element={<ReactShadcnOverviewPage />} />
            <Route path="react/shadcn/quick-start" element={<ReactShadcnQuickStartPage />} />
            <Route path="react/shadcn/features" element={<ReactShadcnFeaturesPage />} />
            <Route path="react/shadcn/architecture" element={<ReactShadcnArchitecturePage />} />
            <Route path="react/shadcn/components" element={<ReactShadcnComponentsPage />} />
            <Route path="react/shadcn/services" element={<ReactShadcnServicesPage />} />
            <Route path="react/shadcn/state" element={<ReactShadcnStatePage />} />
            <Route path="react/shadcn/theming" element={<ReactShadcnThemingPage />} />
            
            {/* React + Tailwind Routes */}
            <Route path="react/tailwind" element={<ReactTailwindOverviewPage />} />
            <Route path="react/tailwind/quick-start" element={<ReactTailwindQuickStartPage />} />
            <Route path="react/tailwind/features" element={<ReactTailwindFeaturesPage />} />
            <Route path="react/tailwind/architecture" element={<ReactTailwindArchitecturePage />} />
            <Route path="react/tailwind/components" element={<ReactTailwindComponentsPage />} />
            <Route path="react/tailwind/services" element={<ReactTailwindServicesPage />} />
            <Route path="react/tailwind/state" element={<ReactTailwindStatePage />} />
            
            {/* Next.js + Shadcn Routes */}
            <Route path="nextjs/shadcn" element={<NextShadcnOverviewPage />} />
            <Route path="nextjs/shadcn/quick-start" element={<NextShadcnQuickStartPage />} />
            <Route path="nextjs/shadcn/features" element={<NextShadcnFeaturesPage />} />
            <Route path="nextjs/shadcn/architecture" element={<NextShadcnArchitecturePage />} />
            <Route path="nextjs/shadcn/components" element={<NextShadcnComponentsPage />} />
            <Route path="nextjs/shadcn/server-client" element={<NextShadcnServerClientPage />} />
            <Route path="nextjs/shadcn/state" element={<NextShadcnStatePage />} />
            
            {/* Next.js + Tailwind Routes */}
            <Route path="nextjs/tailwind" element={<NextTailwindOverviewPage />} />
            <Route path="nextjs/tailwind/quick-start" element={<NextTailwindQuickStartPage />} />
            <Route path="nextjs/tailwind/features" element={<NextTailwindFeaturesPage />} />
            <Route path="nextjs/tailwind/architecture" element={<NextTailwindArchitecturePage />} />
            <Route path="nextjs/tailwind/components" element={<NextTailwindComponentsPage />} />
            <Route path="nextjs/tailwind/server-client" element={<NextTailwindServerClientPage />} />
            <Route path="nextjs/tailwind/state" element={<NextTailwindStatePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
